import React from "react"
import Ajax from "../../../Ajax"
import { Alert, AlertModal } from "../../.."
import { Button } from "@mui/material"
import { observer } from "mobx-react-lite"
import { Icons } from "../../../misc/Icons"
import { store } from "../../../stores/Store"
import { Questionnaire } from "../../../models/Interfaces"
import QuestionnaireDetails from "../../views/questionnaire/QuestionnaireDetails"
import QuestionnaireSelectMultipleField from "../questionnaire/QuestionnaireSelectMulitpleField"
import ViewQuestionnaire from "../../views/questionnaire/ViewQuestionnaire"


export default observer(function EnquiryResume () {

    const [loading, setLoading] = React.useState(false)
    const [questionnaireUidArray, setQuestionnaireUidArray] = React.useState<string[]>([])

    React.useEffect(() => {
        // Prepopulate template filter
        var selectedStatusNode = store.EnquiryStore.enquiryStatuses?.find(sn => sn.selected === true)
        if (selectedStatusNode) { 
            store.QuestionnaireStore.setSearchTemplateKeysByStatusId(selectedStatusNode.code)
        }
    }, [])

    const submit = async () => {
        setLoading(true)
        
        await Ajax.Enquiry.Run(store.EnquiryStore.enquiry.uid, questionnaireUidArray).then(() => {
            store.AlertStore.Close()
        }).catch((response) => {
            Alert({message: response.data?.detail ? response.data.detail : "Couldn't resume enquiry"})
        })
        
        setLoading(false)
    }

    var highlightedOptions = store.EnquiryStore.enquiry?.dataSources
        ? store.EnquiryStore.enquiry.dataSources.map((source) => source.sourceUid)
        : []

    return (
        <div className="form">
            <div>
                <p>Select a Questionnaire to load answers in the enquiry (optional).</p>

                <QuestionnaireSelectMultipleField
                    value={questionnaireUidArray} 
                    highlightedOptions={highlightedOptions}
                    onChange={(questionnaireUidArray) => setQuestionnaireUidArray(questionnaireUidArray)} />
            </div>

            <div className="form-buttons">
                <Button className="btn btn-sm" onClick={() => store.AlertStore.Close()}>
                    Cancel 
                </Button>
                
                <Button 
                    className="btn btn-sm"
                    color="success"
                    variant="contained"
                    disabled={loading}
                    onClick={() => submit()}>
                    {questionnaireUidArray ? "Run using this selection" : "Run without questionnaire"}
                </Button>
            </div>
        </div>
    )
})